import React,{useState} from "react";
import "./header.css";
import mouseicon from "../assets/mouse.png";

import Lottie from "lottie-react";
import Rocket from "../animations/rocket.json";

function Header(){

  const [isVisible, setIsVisible] = useState(false);


  return(
    <div data-aos="" id="Home">
      {/* <div className="navbar">
        <h1 className="navbar-h1" data-aos="fade-down" data-aos-duration="600" data-aos-delay="500">AKSHAT.</h1>
        <li className="header-li">
          <a className="header-anchor" href="#Home" data-aos="fade-down" data-aos-duration="600" data-aos-delay="700">Home</a>
          <a className="header-anchor" href="#About" data-aos="fade-down" data-aos-duration="600" data-aos-delay="900">About</a>
          <a className="header-anchor" href="#Portfolio" data-aos="fade-down" data-aos-duration="600" data-aos-delay="1100">Portfolio</a>
          <a className="header-anchor" href="#Contact" data-aos="fade-down" data-aos-duration="600" data-aos-delay="1300">Contact</a>
        </li>
      </div> */}

      <div className="header-container">

            <div className="card">

                <h1 className="name" data-aos="fade-right" data-aos-duration="600" data-aos-delay="700">HEY, I'M AKSHAT.</h1>
                <div>
                    <h1 className="header-h1" data-aos="fade-right" data-aos-duration="600" data-aos-delay="700">
                      I'm a
                      <span className="header-span"> Frontend Developer</span>
                    </h1>
                </div>
                <div>
                    <p className="header-p" data-aos="fade-right" data-aos-duration="600" data-aos-delay="700">I build things for the web using latest web
                     technologies like React JS, CSS3 and
                     Bootstrap.</p>
                </div>
                <div>
                    <button className="header-button" data-aos="fade-right" data-aos-duration="600" data-aos-delay="700"><a className="header-button-a" href="#Contact">Contact me</a></button>
                </div>

            </div>

            <div className="header-animation-div">
                <div className="header-animation">
                    <Lottie animationData={Rocket}/>
                </div>
            </div>

        </div>
    </div>
  );
}

export default Header;
